import { useContext } from 'react';
import IndicatorsContext from '../contexts/IndicatorsContext';

const useIndicators = () => useContext(IndicatorsContext);

export default useIndicators;
